/**
 * @module Experience/Shop/Cart
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const ACCOUNT_SETUP_CONSTANTS = {
  ACCOUNT_SETUP_MODULE: 'AccountSetupModule',
  ACCOUNT_HOLDER_INFO_COMPONENT: 'AccountHolderInfoComponent',
  SEGMENTATION_COMPONENT: 'SegmentationComponent',
  SEGMENTATION_MODAL_COMPONENT: 'SegmentationModalComponent',
  BILLING_ADDRESS_COMPONENT: 'BillingAddressComponent',
  ACCOUNT_SETUP_LANDING_COMPONENT: 'AccountSetupLandingComponent',
  ACCOUNT_SETUP_SERVICE: 'AccountSetupService',
  PASSWORD: 'password',
  TEXT: 'text',
  FULL_ADDRESS: 'full',
  POSTAL_CODE: 'postalCode',
  ADDRESS_LINE1: 'addressLine1',
  ADDRESS_LINE2: 'addressLine2',
  STATE_CODE: 'stateCode',
  CITY_NAME: 'cityName',
  URBANIZATION: 'urbanization',
  URBANIZATION_CODE: 'urbanizationCode',
  ZIP_ADDRESS: 'zip',
  EMAIL_COMMUNICATION: 'EMAIL_COMMUNICATION',
  PHONE_COMMUNICATION: 'PHONE_COMMUNICATION',
  LANGUAGE: 'customerLanguagePreference',
  ADDRESS_TYPE_BILLING: 'BILLING',
  WEB: 'web',
  ENGLISH: 'en',
  SPANISH: 'es',
  DISPLAY_VALUE: 'displayValue',
  HARDSTOP: 'hardstop',
  MIDDLE_NAME_MAX_LENGTH: '2',
  ALLOWED: 'allowed',
  WARNING: 'warning',
  LEGAL_TEXT: 'legal-text',
  TOURIST: 'tourist',
  PROFILE_EXISTS: 'profile_exists',
  TEMP_PIN_EXPIRED: 'temp_pin_expired',
};

export const MODAL_SETUP_CONSTANTS = {
  CANCEL: 'Cancel',
  CANCEL_CLASS: 'btn btn-secondary',
  CANCEL_TYPE: 'secondary',
  CANCEL_ID: 'cancelBtn',
  EDIT: 'Edit cart',
  EDIT_CLASS: 'btn btn-primary',
  EDIT_TYPE: 'submit',
  EDIT_ID: 'editCartBtn',
};
